webpackJsonp([114276838955818,60335399758886],{

/***/ 105:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(207);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(105);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function")}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}return call&&(typeof call==="object"||typeof call==="function")?call:self}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}var React=__webpack_require__(1);var PureComponent=React.PureComponent;var PropTypes=__webpack_require__(8);var objectAssign=__webpack_require__(5);function noop(){}var Iframe=function(_PureComponent){_inherits(Iframe,_PureComponent);function Iframe(){_classCallCheck(this,Iframe);return _possibleConstructorReturn(this,(Iframe.__proto__||Object.getPrototypeOf(Iframe)).apply(this,arguments))}_createClass(Iframe,[{key:"render",value:function render(){var props={ref:"iframe",frameBorder:"0",src:this.props.url,target:"_parent",sandbox:this.props.sandbox||"allow-forms allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-top-navigation",allowFullScreen:this.props.allowFullScreen||false,style:objectAssign({},{position:this.props.position||"absolute",display:this.props.display||"block",height:this.props.height||"100%",width:this.props.width||"100%"},this.props.styles||{}),height:this.props.height||"100%",name:this.props.name||"",width:this.props.width||"100%",onLoad:this.props.onLoad||noop,onMouseOver:this.props.onMouseOver||noop,onMouseOut:this.props.onMouseOut||noop};return React.createElement("iframe",objectAssign(props,this.props.id?{id:this.props.id}:{},this.props.className?{className:this.props.className}:{}))}}]);return Iframe}(PureComponent);Iframe.propTypes={url:PropTypes.string.isRequired,id:PropTypes.string,className:PropTypes.string,width:PropTypes.string,position:PropTypes.string,display:PropTypes.string,name:PropTypes.string,height:PropTypes.string,onLoad:PropTypes.func,sandbox:PropTypes.string,onMouseOver:PropTypes.func,onMouseOut:PropTypes.func,styles:PropTypes.object,allowFullScreen:PropTypes.bool};exports.default=Iframe;


/***/ }),

/***/ 366:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIframe = __webpack_require__(434);
	
	var _reactIframe2 = _interopRequireDefault(_reactIframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(props) {
	    return _react2.default.createElement(
	        'section',
	        { id: 'contact' },
	        _react2.default.createElement(
	            'div',
	            { className: 'inner' },
	            _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Things to do in Portsmouth, UK'
	                ),
	                _react2.default.createElement(_reactIframe2.default, { url: ' https://www.tripadvisor.com/Attractions-g186298-Activities-Portsmouth_Hampshire_England.html',
	                    width: '100%',
	                    height: '400px',
	                    id: 'trip-advisor-iframe',
	                    className: 'tripadvisor-wrapper',
	                    position: 'relative'
	                }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('hr', null),
	                _react2.default.createElement(
	                    'h4',
	                    { className: 'contact-heading' },
	                    'Get in touch'
	                ),
	                _react2.default.createElement(
	                    'form',
	                    { method: 'POST', name: 'contact', 'data-netlify': 'true' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'field half first' },
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'name' },
	                            'Name'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', name: 'name', id: 'name' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'field half' },
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'email' },
	                            'Email'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', name: 'email', id: 'email' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'field' },
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'message' },
	                            'Message'
	                        ),
	                        _react2.default.createElement('textarea', { name: 'message', id: 'message', rows: '6' })
	                    ),
	                    _react2.default.createElement('div', { 'data-netlify-recaptcha': true }),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'actions' },
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('input', { type: 'submit', value: 'Send Message', className: 'special' })
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('input', { type: 'reset', value: 'Clear' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { className: 'split', id: 'news' },
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        'The news'
	                    ),
	                    _react2.default.createElement(_reactIframe2.default, { url: 'https://www.portsmouth.co.uk/news/',
	                        width: '100%',
	                        height: '400px',
	                        id: 'portsmouth-news-iframe',
	                        className: 'portsmouth-wrapper',
	                        position: 'relative'
	                    })
	                ),
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'contact-method' },
	                        _react2.default.createElement('span', { className: 'icon alt fa-arrow-right' }),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/news/gay-asylum-seeker-deportation' },
	                            'Concern over gay asylum seeker deportation'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'contact-method' },
	                        _react2.default.createElement('span', { className: 'icon alt fa-arrow-right' }),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/portsmouth' },
	                            'Portsmouth, UK'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'contact-method' },
	                        _react2.default.createElement('span', { className: 'icon alt fa-arrow-right' }),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/news/hms-queen-elizabeth' },
	                            'HMS Queen Elizabeth: Was It Necessary?'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'contact-method' },
	                        _react2.default.createElement('span', { className: 'icon alt fa-arrow-right' }),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/mps-for-portsmouth' },
	                            'MPs For Portsmouth'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'contact-method' },
	                        _react2.default.createElement('span', { className: 'icon alt fa-arrow-right' }),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/news/homeowners-forced-to-accept-lower-prices-portsmouth' },
	                            'Homeowners Forced To Accept Lower Sale Prices in Portsmouth'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'contact-method' },
	                        _react2.default.createElement('span', { className: 'icon alt fa-arrow-right' }),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/news/shelter-for-the-homeless' },
	                            'Shelter For The Homeless'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	    return _react2.default.createElement(
	        "footer",
	        { id: "footer" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "ul",
	                { className: "copyright" },
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: "label" },
	                        "2018 \xA9 Mike Hancock"
	                    )
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "mailto:contact@mikehancock.com" },
	                        "contact@mikehancock.com"
	                    )
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "/about" },
	                        "about"
	                    )
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "/contact-me" },
	                        "contact"
	                    )
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: "/sitemap.xml" },
	                        "sitemap"
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	    return _react2.default.createElement(
	        'header',
	        { id: 'header', className: 'alt' },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', className: 'logo' },
	            _react2.default.createElement(
	                'strong',
	                null,
	                'mike'
	            ),
	            ' ',
	            _react2.default.createElement(
	                'span',
	                null,
	                'hancock'
	            )
	        ),
	        _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement('a', { className: 'menu-link', onClick: props.onToggleMenu, href: 'javascript:;' })
	        )
	    );
	};
	
	Header.propTypes = {
	    onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(props) {
	    return _react2.default.createElement(
	        'nav',
	        { id: 'menu' },
	        _react2.default.createElement(
	            'div',
	            { className: 'inner' },
	            _react2.default.createElement(
	                'ul',
	                { className: 'links' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/' },
	                        'Home'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/#news' },
	                        'Latest News'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/about' },
	                        'About'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { onClick: props.onToggleMenu, to: '/contact-me' },
	                        'Get in touch'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'a',
	            { className: 'close', onClick: props.onToggleMenu, href: 'javascript:;' },
	            'Close'
	        )
	    );
	};
	
	Menu.propTypes = {
	    onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(21);
	
	__webpack_require__(366);
	
	var _Header = __webpack_require__(205);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Menu = __webpack_require__(206);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Contact = __webpack_require__(203);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Footer = __webpack_require__(204);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	    _inherits(Template, _React$Component);
	
	    function Template(props) {
	        _classCallCheck(this, Template);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            isMenuVisible: false,
	            loading: 'is-loading'
	        };
	        _this.handleToggleMenu = _this.handleToggleMenu.bind(_this);
	        return _this;
	    }
	
	    Template.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.timeoutId = setTimeout(function () {
	            _this2.setState({ loading: '' });
	        }, 100);
	    };
	
	    Template.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.timeoutId) {
	            clearTimeout(this.timeoutId);
	        }
	    };
	
	    Template.prototype.handleToggleMenu = function handleToggleMenu() {
	        this.setState({
	            isMenuVisible: !this.state.isMenuVisible
	        });
	    };
	
	    Template.prototype.render = function render() {
	        var children = this.props.children;
	
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'body ' + this.state.loading + ' ' + (this.state.isMenuVisible ? 'is-menu-visible' : '') },
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement('link', { rel: 'stylesheet', href: (0, _gatsbyLink.withPrefix)('skel.css') })
	            ),
	            _react2.default.createElement(
	                'div',
	                { id: 'wrapper' },
	                _react2.default.createElement(_Header2.default, { onToggleMenu: this.handleToggleMenu }),
	                children(),
	                _react2.default.createElement(_Contact2.default, null),
	                _react2.default.createElement(_Footer2.default, null)
	            ),
	            _react2.default.createElement(_Menu2.default, { onToggleMenu: this.handleToggleMenu })
	        );
	    };
	
	    return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	    children: _react2.default.PropTypes.func
	};
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-62ecc594bd0de1e8de74.js